<form [formGroup]="form" class="needs-validation">
  <div class="position-relative row form-group">
    <label for="name_Id" class="col-sm-2 col-form-label"
      >{{ "Form.NAME" | translate }} <span class="text-danger">*</span></label
    >
    <div class="col-sm-10">
      <input
        maxlength="70"
        formControlName="name"
        name="name"
        placeholder="Workflow Step Name"
        id="name_Id"
        type="text"
        class="form-control"
        required
        [readonly]="currentWorkflowStep.parentId"
      />
      <div *ngIf="submitted && f.name.errors" class="invalid-feedback">
        <div *ngIf="f.name.errors.required">
          {{ "Form.Error.NAME" | translate }}
        </div>
      </div>
    </div>
  </div>

  <div class="position-relative mb-2 pb-2 row form-group">
    <label class="col-sm-2 col-form-label" for="workflowTypeElement"
      >{{ "Form.WorkflowType" | translate }}
    </label>
    <div class="col-sm-10">
      <div class="custom-radio custom-control">
        <input
          class="custom-control-input"
          id="text"
          name="workflowStepType"
          type="radio"
          value="text"
          formControlName="workflowStepType"
        />
        <label class="custom-control-label" for="text">{{
          "Form.Text" | translate
        }}</label>
      </div>

      <div class="custom-radio custom-control">
        <input
          class="custom-control-input"
          id="stepclick"
          name="workflowStepType"
          type="radio"
          value="click"
          formControlName="workflowStepType"
        />
        <label class="custom-control-label" for="stepclick">{{
          "Form.Click" | translate
        }}</label>
      </div>
    </div>
  </div>

  <div class="d-flex justify-content-end">
    <button
      style="
        border: none;
        border-radius: 50px;
        background-color: rgb(255, 238, 0);
        width: 25px;
        height: 25px;
        text-align: center;
      "
      (click)="generateContentForWorkflowStep()"
    >
      <i
        id="suggest-workflow-step"
        style="font-size: 18px"
        class="fa fa-lightbulb-o"
        title="Suggest User Guide content"
      ></i>
    </button>
  </div>
  <div
    class="position-relative row form-group d-flex mt-2 pt-2 justify-content-between"
    *ngIf="form.get('workflowStepType').value == 'text'"
  >
    <label for="intro" class="col-sm-2 col-form-label"
      >{{ "Form.Text" | translate }}<span class="text-danger">*</span></label
    >
    <div
      class="col-sm-10 mb-2 pb-2 form-group"
      *ngIf="form.get('workflowStepType').value == 'text'"
    >
      <angular-editor
        formControlName="intro"
        [config]="config"
        required
      ></angular-editor>
      <div *ngIf="submitted && textError" class="text-danger">
        {{ "Form.TextERR" | translate }}
      </div>
    </div>
  </div>

  <div class="position-relative row mb-1 pb-1 form-group">
    <label for="elementSelector" class="col-sm-2 col-form-label">{{
      "Form.ElementSelector" | translate
    }}</label>
    <div class="col-sm-10">
      <select
        id="elementSelector"
        class="form-control"
        name="elementSelector"
        formControlName="elementSelector"
      >
        <option value="">Select Element Identifier</option>
        <option value="Id">Id</option>
        <option value="Class">Class</option>
        <option value="Path">Path</option>
        <option value="Name">Name</option>
        <option value="TagName">Tag Name</option>
        <option value="XPath">XPath</option>
      </select>
    </div>
  </div>

  <div class="position-relative row mb-1 pb-1 form-group">
    <label for="element" class="col-sm-2 col-form-label">{{
      "Form.Element" | translate
    }}</label>
    <div class="col-sm-10">
      <input
        formControlName="element"
        placeholder="{{ 'Form.Element' | translate }}"
        name="element"
        id="element"
        type="text"
        class="form-control"
      />
    </div>
  </div>
  <div class="position-relative row form-group">
    <label for="position" class="col-sm-2 col-form-label">
      {{ "Form.SRoles" | translate }}
    </label>
    <ng-select
      [items]="availableRoles"
      [virtualScroll]="true"
      bindLabel="displayname"
      bindValue="name"
      placeholder="{{ 'Form.SRoles' | translate }}"
      class="mb-1 pb-1 col-sm-10"
      [multiple]="true"
      formControlName="roles"
    >
    </ng-select>
  </div>
  <div class="position-relative mb-1 pb-1 row form-group">
    <label for="displayStep" class="col-sm-2 col-form-label"
      >{{ "Form.StepOrder" | translate
      }}<span class="text-danger">*</span></label
    >
    <div class="col-sm-10">
      <input
        formControlName="displayStep"
        name="displayStep"
        id="displayStep"
        type="number"
        class="form-control"
      />
      <div *ngIf="submitted && f.displayStep.errors" class="invalid-feedback">
        <div *ngIf="f.displayStep.errors.required">
          {{ "Form.displayStepErr" | translate }}
        </div>
      </div>
    </div>
  </div>

  <!-- Next Page section -->
  <div class="row mb-2">
    <label class="col-sm-2 col-form-label">Next Page</label>
    <div class="col-sm-10">
      <div class="d-flex gap-3 mb-2">
        <div class="form-check">
          <input class="form-check-input" type="radio" id="npTypeUrl" name="npType"
            value="url" [(ngModel)]="nextPageType" [ngModelOptions]="{standalone: true}"
            (change)="onNextPageTypeChange('url')" />
          <label class="form-check-label" for="npTypeUrl">URL</label>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="radio" id="npTypeElement" name="npType"
            value="element" [(ngModel)]="nextPageType" [ngModelOptions]="{standalone: true}"
            (change)="onNextPageTypeChange('element')" />
          <label class="form-check-label" for="npTypeElement">Element</label>
        </div>
      </div>

      <!-- URL input -->
      <div *ngIf="nextPageType === 'url'">
        <input [(ngModel)]="nextPageUrlValue" [ngModelOptions]="{standalone: true}"
          (ngModelChange)="markFormDirty()"
          placeholder="Enter next page URL" type="text" class="form-control" />
      </div>

      <!-- Element slots (max 4) -->
      <div *ngIf="nextPageType === 'element'">
        <div *ngFor="let el of nextPageElements; let i = index"
          class="mb-3 p-2" style="border:1px solid #ddd;border-radius:6px;">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <span class="fw-bold text-primary" style="font-size:13px;">Element {{i + 1}}</span>
            <button type="button" class="btn btn-sm btn-outline-danger"
              *ngIf="i > 0" (click)="removeNextPageElement(i)">×</button>
          </div>
          <p class="mb-1 fw-bold" style="font-size:12px;">Element Identifier</p>
          <div *ngFor="let ident of npIdentifiers" class="form-check mb-2">
            <input class="form-check-input" type="radio"
              [name]="'npIdent_' + i"
              [id]="'npIdent_' + i + '_' + ident.value"
              [value]="ident.value"
              [(ngModel)]="el.elementIdentifier"
              [ngModelOptions]="{standalone: true}"
              (ngModelChange)="markFormDirty()" />
            <label class="form-check-label" [for]="'npIdent_' + i + '_' + ident.value">
              {{ident.label}}
            </label>
            <input type="text" class="form-control form-control-sm mt-1"
              [placeholder]="ident.placeholder"
              [(ngModel)]="el[ident.valKey]"
              [ngModelOptions]="{standalone: true}"
              (ngModelChange)="markFormDirty()" />
          </div>
        </div>
        <button type="button" class="btn btn-sm btn-outline-primary"
          *ngIf="nextPageElements.length < 4" (click)="addNextPageElement()">+ Add Element</button>
      </div>
    </div>
  </div>

  <!-- Next Page Button (legacy field) -->
  <div class="row">
    <label for="nextPageButton" class="col-sm-2 col-form-label">Next Page Button</label>
    <div class="col-sm-10">
      <input formControlName="nextPageButton" name="nextPageButton"
        placeholder="Element ID (e.g. #submit-btn)"
        id="nextPageButton" type="text" class="form-control" />
    </div>
  </div>

  <div class="row">
    <div class="col-sm-10">
      <button
        class="btn btn-primary"
        style="margin-right: 10px"
        type="submit"
        [disabled]="!form.dirty"
        (click)="onSubmit()"
      >
        {{ "Form.SAVE" | translate }}
      </button>
      <button
        class="btn btn-secondary"
        (click)="onReset()"
        [disabled]="!form.dirty"
      >
        {{ "Form.CANCEL" | translate }}
      </button>
    </div>
  </div>

  <div class="divider"></div>
</form>

<!-- <div
  class="card-header-tab card-header"
  style="margin-bottom: -1px; border-bottom-width: 0px; padding: 3px"
  *ngIf="!addStep"
>
  <div class="card-title font-size-md text-capitalize">
    {{ "Form.SELECT_LANGUAGE" | translate }}
  </div>
</div>

<div
  class="row"
  *ngIf="project && project.supportedLanguage && !addStep"
  style="margin-left: -5px"
>
  <div
    style="
      padding: 10px;
      cursor: pointer;
      margin-bottom: 4px;
      font-size: 11px;
      height: fit-content;
    "
    class="badge ms-2 col-md-1"
    [ngClass]="{
      'badge-primary':
        currentWorkflowStep.languageId == project.primaryLanguage,
      'badge-secondary':
        currentWorkflowStep.languageId != project.primaryLanguage
    }"
    (click)="showSelectedLangaugeTooltip(project.primaryLanguage)"
  >
    {{ getLanguageName(project.primaryLanguage) }}
  </div>
  <ng-container *ngFor="let psl of project.supportedLanguage">
    <div
      style="
        padding: 10px;
        cursor: pointer;
        margin-bottom: 4px;
        font-size: 11px;
        height: fit-content;
      "
      *ngIf="psl.id != project.primaryLanguage"
      class="badge ms-2 col-md-1"
      [ngClass]="{
        'badge-primary': psl.id == currentWorkflowStep.languageId,
        'badge-secondary': psl.id != currentWorkflowStep.languageId
      }"
      (click)="showSelectedLangaugeTooltip(psl.id)"
    >
      {{ psl.name }}
    </div>
  </ng-container>

  <ng-template #content let-c="close" let-d="dismiss">
    <div class="modal-header">
      <h4 class="modal-title">
        {{ "Form.SELECT_NEW_LANGUAGE" | translate }}
      </h4>
      <button
        type="button"
        class="close mt-2"
        aria-label="Close"
        (click)="d('Cross click')"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body lang-popup">
      <overlay-scrollbars [defer]="true">
        <mat-selection-list #newLanguages class="me-2">
          <mat-list-option *ngFor="let projectSl of getNewLanguage()">
            {{ projectSl.name }}
          </mat-list-option>
        </mat-selection-list>
      </overlay-scrollbars>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-secondary"
        (click)="c('Close click')"
      >
        {{ "Form.CANCEL" | translate }}
      </button>
      <button
        type="button"
        class="btn btn-primary"
        (click)="saveNewSelectedLanguage(newLanguages)"
      >
        {{ "Form.SAVE" | translate }}
      </button>
    </div>
  </ng-template>
  <div
    style="
      padding: 10px;
      cursor: pointer;
      margin-bottom: 4px;
      font-size: 11px;
      height: fit-content;
    "
    class="badge ms-2 badge-primary col-1"
    (click)="open(content)"
  >
    +
  </div>
</div> -->

<div
  class="card-header-tab card-header"
  style="margin-bottom: -1px; border-bottom-width: 0px; padding: 3px"
  *ngIf="currentWorkflowStep.updatedAt"
>
  <div class="card-title font-size-md text-capitalize">
    {{ "Form.Lastupdatedon" | translate }}
    {{ currentWorkflowStep.updatedAt | date : "yyyy-MM-dd" }}
  </div>
</div>
